@if (!big) {
  @if (white) {
    @if (prefix != null) {
      <span style="margin-right: 5px; color: white!important;">{{ prefix }}</span>
    }
    @if (variable != null) {
      <span class="variable-white" style="margin-right: 5px;">{{ variable }}</span>
    }
    @if (suffix != null) {
      <span style="margin-right: 5px; color: white!important;">{{ suffix }}</span>
    }
  } @else {
    @if (prefix != null) {
      <span style="margin-right: 5px;">{{ prefix }}</span>
    }
    @if (variable != null) {
      <span class="variable" style="margin-right: 5px;">{{ variable }}</span>
    }
    @if (suffix != null) {
      <span style="margin-right: 5px;">{{ suffix }}</span>
    }
  }
} @else {
  @if (white) {
    @if (prefix != null) {
      <span style="margin-right: 5px; color: white!important; font-size: 27px;">{{ prefix }}</span>
    }
    @if (variable != null) {
      <span class="variable-white" style="margin-right: 5px; font-size: 27px;">{{ variable }}</span>
    }
    @if (suffix != null) {
      <span style="margin-right: 5px; color: white!important; font-size: 27px;">{{ suffix }}</span>
    }
  } @else {
    @if (prefix != null) {
      <span style="margin-right: 5px; font-size: 27px;">{{ prefix }}</span>
    }
    @if (variable != null) {
      <span class="variable" style="margin-right: 5px; font-size: 27px;">{{ variable }}</span>
    }
    @if (suffix != null) {
      <span style="margin-right: 5px; font-size: 27px;">{{ suffix }}</span>
    }
  }
}
